import React, { Children } from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: '🔥',
  title: 'Reactivar tu metabolismo',
  description: 'Estrategias naturales para despertar un metabolismo que se ha vuelto lento después de los 40'
}, {
  icon: '🧠',
  title: 'Entender qué le pasa a tu cuerpo',
  description: 'Descubre por qué tu cuerpo responde diferente y qué hacer al respecto'
}, {
  icon: '🌿',
  title: 'Reducir inflamación sin dietas extremas',
  description: 'Identifica qué te inflama y cómo sentirte más ligera sin privarte de todo'
}, {
  icon: '⚡',
  title: 'Recuperar tu energía',
  description: 'Dile adiós al cansancio constante y vuelve a tener la vitalidad que extrañas'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function BenefitsGrid() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-olive" data-id="element-22">
            Empieza a sentir estos cambios en tu cuerpo
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-23">
          {benefits.map((benefit, idx) => <motion.div key={idx} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-card hover:shadow-soft transition-shadow duration-300 flex flex-col items-start" data-id="element-24">
              <div className="text-4xl mb-4 bg-cream w-16 h-16 rounded-full flex items-center justify-center" data-id="element-25">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-olive mb-3 font-heading" data-id="element-26">
                {benefit.title}
              </h3>
              <p className="text-warm-gray leading-relaxed" data-id="element-27">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}